// extracted by mini-css-extract-plugin
export var externalLink = "_af-0";
export var internalLinkLabel = "_af-1";